import { Button, ButtonVariant, LayoutWithSidebar } from "@swivl-mono/ui";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { SearchableSidebarLinksList } from "../../../Components/SidebarLink/SearchableSidebarLinksList";
import BrandsModel from "../../../Models/Brands/Brands.Model";

export default function BrandsView() {
  const brands = BrandsModel.useState((state) => state.brands);
  useEffect(() => {
    BrandsModel.load(false);
  }, []);

  let items: any[] = [];
  if (brands) {
    items = Object.values(brands).map((brand) => {
      return {
        to: `properties/page/brands/${brand.id}`,
        label: brand.isDefault ? brand.name + " (Default)" : brand.name
      };
    });
  }

  return (
    <LayoutWithSidebar
      sidebar={
        <>
          <SearchableSidebarLinksList prefix={""} suffix={""} items={items} />
          <Button
            variant={ButtonVariant.GHOST}
            onClickAsync={async () => {
              await BrandsModel.create();
            }}
          >
            + Add Brand
          </Button>
        </>
      }
      contentNoPadding={true}
      content={
        <div className="p-5">
          <Outlet />
        </div>
      }
    />
  );
}
